import React, { createContext, useContext } from 'react';
import { useFinanceData } from '../hooks/useFinanceData';

const FinanceDataContext = createContext(null);

export const FinanceDataProvider = ({ children }) => {
  const financeData = useFinanceData();

  return (
    <FinanceDataContext.Provider value={financeData}>
      {children}
    </FinanceDataContext.Provider>
  );
};

export const useFinanceDataContext = () => {
  const context = useContext(FinanceDataContext);
  if (!context) {
    throw new Error('useFinanceDataContext must be used within a FinanceDataProvider');
  }
  return context;
};

export default FinanceDataContext;
